import {
  Component,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TextInput } from '../text-input/text-input';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'andor-password-confirm-inputs',
  standalone: true,
  imports: [TextInput, TranslatePipe, FormsModule, ReactiveFormsModule],
  templateUrl: './password-confirm-inputs.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './password-confirm-inputs.scss',
})
export class PasswordConfirmInputs implements OnInit {
  password = input('');
  @Input() labelPassword = '';
  @Input() labelConfirmPassword = '';
  @Output() changed = new EventEmitter<string>();
  @Output() valid = new EventEmitter<boolean>();
  @Output() touched = new EventEmitter<boolean>();

  adminPasswordForm = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(256),
    ]),
    confirmPassword: new FormControl('', [
      (control: AbstractControl) => {
        return control?.value === this.adminPasswordForm?.controls.password.value
          ? null
          : { mismatch: true };
      },
      Validators.required,
    ]),
  });

  constructor() {
    this.adminPasswordForm.valueChanges.pipe(takeUntilDestroyed()).subscribe(() => {
      const { password, confirmPassword } = this.adminPasswordForm.controls;
      // Revalidate confirmation when the original password changes as well.
      confirmPassword.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      this.adminPasswordForm.updateValueAndValidity({ emitEvent: false });
      this.touched.emit(!!password.value || !!confirmPassword.value);
      this.valid.emit(this.adminPasswordForm.valid);
      this.changed.emit(password.value ?? '');
    });
  }

  reset() {
    this.adminPasswordForm.reset();
  }

  ngOnInit(): void {
    this.adminPasswordForm.controls.password.patchValue(this.password());
    this.adminPasswordForm.controls.confirmPassword.patchValue(this.password());
  }
}
